// 有多少import多少
import bz from './bz/index.js'
import gzh from './gzh/index.js'
export default {
  bz,
  gzh
}
